import { useCallback, useRef } from "react";
import { signOut } from "next-auth/react";

import { useToast } from "./useToast";
import { logout } from "../modules/auth/api/auth";
import { useRouter } from "next/navigation";

/**
 * Hook that returns a function that signs out a user.
 */
export default function useSignOut() {
    const { addToast } = useToast();
    const router = useRouter();

    // Ensures the sign out logic is can only run once per call.
    const isLoggingOut = useRef(false);

    return useCallback(async () => {
        if (isLoggingOut.current) {
            return;
        }

        isLoggingOut.current = true;

        // Invalidate tokens API side.
        const response = await logout();

        if (!response.success && response.status !== 401) {
            isLoggingOut.current = false;
            addToast("Unable to logout. Please contact support", "error");
            return;
        }

        // Remove tokens stored in cookies.
        await signOut({
            redirect: false,
        });

        router.push("/auth/signed-out");
    }, [router, addToast]);
};
